import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { SysConfig } from "__SYSDefault/Config";
import ClaimRowM from "./_gears/ClaimRowM";
import ClaimRowW from "./_gears/ClaimRowW";

/**
 * @augments {Component<Props, State>}
 */
class ClaimRow extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ClaimRow.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  render(){
    return ResponsiveX.Split({
      0: () => <ClaimRowM {...this.props} />,
      [SysConfig.WebUIWidth]: () => <ClaimRowW {...this.props} />
    });
  }

}

export default observer(ClaimRow);
